import React, { useState, useRef, useEffect } from "react";
import { Bell, User, ChevronDown, Settings, LogOut, Menu, Sun, Moon } from "react-feather";
import { useTheme } from "../theme/ThemeContext";
import { useAuth } from "../auth/AuthContext";

const Navbar = ({ collapsed, toggleSidebar }) => {
  const { logout } = useAuth();
  const [profileOpen, setProfileOpen] = useState(false);
  const profileRef = useRef(null);
  const { theme, toggleTheme, tokens, fonts } = useTheme();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setProfileOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const notificationsCount = 5;

  return (
    <nav style={{ ...styles.navbar, backgroundColor: tokens.topbarBg }}>
      <div style={styles.leftGroup}>
        <button onClick={toggleSidebar} style={styles.toggleBtn} aria-label="Toggle sidebar">
          <Menu size={22} color={tokens.topbarText} />
        </button>

        <div style={styles.brand}>
          <div style={{ ...styles.brandMark, backgroundColor: tokens.accent }}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={tokens.accentContrast} strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 5l6 7-6 7" />
              <path d="M12 5l6 7-6 7" />
            </svg>
          </div>
          <span style={{ ...styles.dashboardText, fontFamily: fonts.display, color: tokens.topbarText }}>budgetsprint</span>
        </div>
      </div>

      <div style={styles.rightGroup}>
        <button
          onClick={toggleTheme}
          aria-label={theme === "light" ? "Switch to dark mode" : "Switch to light mode"}
          style={{ ...styles.iconBtn, backgroundColor: tokens.topbarBgActive }}
        >
          {theme === "light" ? <Moon size={16} color={tokens.topbarText} /> : <Sun size={16} color={tokens.accent} />}
        </button>

        <div style={styles.notificationWrapper}>
          <Bell size={22} color={tokens.topbarText} />
          {notificationsCount > 0 && (
            <span style={{ ...styles.badge, backgroundColor: tokens.accent, color: tokens.accentContrast }}>{notificationsCount}</span>
          )}
        </div>

        <div
          style={styles.profileWrapper}
          ref={profileRef}
          onClick={() => setProfileOpen(!profileOpen)}
        >
          <User size={22} color={tokens.topbarText} />
          <ChevronDown size={18} color={tokens.topbarText} />
          {profileOpen && (
            <ul style={{ ...styles.dropdown, backgroundColor: tokens.topbarBgActive }}>
              <li style={{ ...styles.dropdownItem, color: tokens.topbarText }}>
                <Settings size={16} style={{ marginRight: 8 }} />
                Settings
              </li>
              <li style={{ ...styles.dropdownItem, color: tokens.topbarText }} onClick={logout}>
                <LogOut size={16} style={{ marginRight: 8 }} />
                Logout
              </li>
            </ul>
          )}
        </div>
      </div>
    </nav>
  );
};

const styles = {
  navbar: {
    height: "60px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 20px",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1100,
    transition: "background-color 0.2s ease",
  },
  leftGroup: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  toggleBtn: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "4px",
    display: "flex",
  },
  brand: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  brandMark: {
    width: "28px",
    height: "28px",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  dashboardText: {
    fontSize: "17px",
    fontWeight: "700",
    letterSpacing: "-0.01em",
  },
  rightGroup: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    position: "relative",
  },
  iconBtn: {
    width: "32px",
    height: "32px",
    borderRadius: "9px",
    border: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  notificationWrapper: {
    position: "relative",
    cursor: "pointer",
    display: "flex",
  },
  badge: {
    position: "absolute",
    top: "-6px",
    right: "-8px",
    borderRadius: "9999px",
    fontSize: "12px",
    fontWeight: "700",
    padding: "2px 6px",
    lineHeight: "1",
  },
  profileWrapper: {
    position: "relative",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  dropdown: {
    position: "absolute",
    top: "calc(100% + 6px)",
    right: 0,
    borderRadius: "6px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
    padding: "8px 0",
    listStyle: "none",
    minWidth: "140px",
    zIndex: 1000,
  },
  dropdownItem: {
    padding: "8px 16px",
    cursor: "pointer",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
  },
};

export default Navbar;
